import AiThinker from "components/Lottie/AiThinker";
import useTranslation from "next-translate/useTranslation";
import React, { useEffect, useState } from "react";
import Countdown from "react-countdown";
import { Button } from "components/ui/v2";

interface LoaderProps {
  title: string;
  body?: React.ReactNode;
  execReq?: () => void;
  cancelReq?: () => void;
}

const debounce = 9000;

const AILoader: React.FC<LoaderProps> = ({
  title,
  body,
  execReq,
  cancelReq,
}) => {
  const [timer, setTimer] = useState<NodeJS.Timeout | undefined>(undefined);

  const { t } = useTranslation("common");

  const handleCancel = () => {
    clearTimeout(timer);
    setTimer(undefined);
    if (cancelReq) {
      cancelReq();
    }
  };

  const sendReq = () => {
    clearTimeout(timer);
    setTimer(undefined);
    if (execReq) {
      execReq();
    }
  };

  useEffect(() => {
    if (execReq) {
      const timerId = setTimeout(() => {
        execReq();
        setTimer(undefined);
      }, debounce);
      setTimer(timerId);
    }
  }, []);

  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="flex max-w-md flex-col items-center justify-center">
        <AiThinker size={200} />

        <span className="mt-4 max-w-xs text-center text-lg font-bold">
          {title}
        </span>

        {body}

        <span className="mb-8 max-w-xs text-center">
          {t("Esto podría llevar unos segundos, pero la espera vale la pena")}
        </span>

        {timer && (
          <Button variant="primary" onClick={sendReq}>
            <span className="mr-2">{`${t("Se ve bien")} `}</span>
            <Countdown
              date={Date.now() + debounce}
              renderer={({ seconds }) => <span>{` 00:0${seconds}`}</span>}
            />
          </Button>
        )}

        {/* Habilitado tambien mientras la peticion esta en curso: antes, pasado
            el debounce, el usuario quedaba atrapado sin salida en el loader. */}
        <Button variant="link" onClick={handleCancel}>
          {t("Cancelar")}
        </Button>
      </div>
    </div>
  );
};

export default AILoader;
